var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tooltip',{attrs:{"z-index":_vm.zIndex,"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-avatar',_vm._g({attrs:{"color":_vm.avatarColor,"size":"32"}},on),[_vm._v(" "+_vm._s(_vm.initials)+" ")])]}}])},[_c('div',[_vm._v(" "+_vm._s(_vm.tooltipText)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }